import { useEffect } from "react";
import learningportalimg from "../../assets/images/learningportal.svg";
import StudentRegistrationForm from "../../components/StudentPortal/StudentRegistration/StudentRegistrationForm";
export default function StudentRegistration() {
  useEffect(() => {
    document.title = "Student Registration - LWS Learning Portal";
  }, []);

  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img
            className="h-12 mx-auto"
            src={learningportalimg}
            alt="Learning Portal"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Create Your New Account
          </h2>
        </div>
        <StudentRegistrationForm />
      </div>
    </section>
  );
}
